import { render, staticRenderFns } from "./WebConfig.vue?vue&type=template&id=87fb69f6&scoped=true"
import script from "./WebConfig.vue?vue&type=script&lang=js"
export * from "./WebConfig.vue?vue&type=script&lang=js"
import style0 from "./WebConfig.vue?vue&type=style&index=0&id=87fb69f6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fb69f6",
  null
  
)

export default component.exports